var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCrmStore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    fillOpacity: 0,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 7l-.907-4.21a1 1 0 00-.977-.79H2.884a1 1 0 00-.977.79L1 7",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 4h6",
    stroke: "currentColor",
    strokeLinecap: "round",
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.077 9v4a1 1 0 001 1h9.846a1 1 0 001-1V9",
    stroke: "currentColor",
    fill: "none"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.667 7c0 1.197-1.045 2.167-2.334 2.167C2.045 9.167 1 8.197 1 7M10.333 7c0 1.197-1.044 2.167-2.333 2.167-1.289 0-2.333-.97-2.333-2.167M15 7c0 1.197-1.044 2.167-2.333 2.167-1.289 0-2.333-.97-2.333-2.167",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })));
}

export default SvgCrmStore;